import { TextAlignment } from '../../canvas/entities/TextConventions';
import { FieldLayout } from '../../canvas/fields/AdaptableField';
import { SimpleTextField } from '../../canvas/fields/SimpleTextField';
import { Topic } from './Topic';

export class TopicLabel extends SimpleTextField {

    public readonly fontColor = '#fff';
    public readonly fontSize = 24;
    public readonly textAlignH = TextAlignment.middle;
    public readonly textAlignV = TextAlignment.middle;

    public get layout(): FieldLayout {
        return this.owner.cast(Topic).layout.label;
    }
}
